import { AnimatePresence } from "motion/react";
import ms from "ms" with { type: "macro" };
import { useState } from "react";
import type { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { Image } from "~/components/image";
import { useTimeout } from "~/hooks/use-interval";
import LogoOnDark from "~/static/logo-on-dark.svg";
import LogoOnLight from "~/static/logo-on-light.svg";

import { LongerThanUsual } from "./longer-than-usual";

export function Loading({
	longerThanUsual: _longerThanUsual,
	className,
	light,
	children
}: PropsWithChildren<{
	className?: string;
	light?: boolean;
	longerThanUsual?: boolean;
}>) {
	const [longerThanUsual, setLongerThanUsual] = useState(_longerThanUsual);
	useTimeout(() => setLongerThanUsual(true), ms("8s"));

	return (
		<div className={twMerge("flex min-h-screen w-full flex-col items-center justify-center opacity-75", className)}>
			<div className="w-2/3 max-w-sm animate-pulse desktop:w-1/2">
				{light !== true && (
					<Image
						priority
						alt=""
						className="hidden w-full dark:block vision:block"
						draggable={false}
						height={1000}
						src={LogoOnDark}
						width={3468}
					/>
				)}
				<Image
					priority
					alt=""
					className={twMerge("w-full", light !== true && "block dark:hidden vision:hidden")}
					draggable={false}
					height={1000}
					src={LogoOnLight}
					width={3468}
				/>
			</div>
			<AnimatePresence>
				{longerThanUsual && (<LongerThanUsual />)}
			</AnimatePresence>
			{children}
		</div>
	);
}
